import SvgIcon from '@mui/material/SvgIcon';

export const ErrorFileImage = () => (
  <SvgIcon width="56" height="56" viewBox="0 0 56 56" fontSize="inherit">
    <path
      d="M35 4C35.5 4 38.3004 3.99961 40.6504 6.34961C43.0004 8.6996 43 11.5 43 12C43 21.5569 42.9999 27.9171 43 38.5C38.3056 38.5 34.5 42.3056 34.5 47C34.5 47.3384 34.5221 47.6719 34.5605 48H19C18.5 48 15.6996 48.0004 13.3496 45.6504C10.9996 43.3004 11 40.5 11 40V12C11 11.5 10.9996 8.69961 13.3496 6.34961C15.6996 3.99961 18.5 4 19 4H35Z"
      fill="#EDF3FF"
    />
    <path
      d="M35 4C39.4183 4 43 7.58172 43 12V38.5C38.3056 38.5 34.5 42.3056 34.5 47C34.5 47.3337 34.5212 47.6627 34.5586 47.9863C30.3457 47.7572 27 44.2701 27 40V12C27 7.58172 30.5817 4 35 4Z"
      fill="#D1E1FF"
    />
    <path
      d="M23 31C23.5523 31 24 31.4477 24 32C24 32.5523 23.5523 33 23 33H16C15.4477 33 15 32.5523 15 32C15 31.4477 15.4477 31 16 31H23ZM38 27C38.5523 27 39 27.4477 39 28C39 28.5523 38.5523 29 38 29H16C15.4477 29 15 28.5523 15 28C15 27.4477 15.4477 27 16 27H38ZM38 23C38.5523 23 39 23.4477 39 24C39 24.5523 38.5523 25 38 25H16C15.4477 25 15 24.5523 15 24C15 23.4477 15.4477 23 16 23H38Z"
      fill="#BFCAE0"
    />
    <path
      d="M38 27C38.5523 27 39 27.4477 39 28C39 28.5523 38.5523 29 38 29H27V27H38ZM38 23C38.5523 23 39 23.4477 39 24C39 24.5523 38.5523 25 38 25H27V23H38Z"
      fill="#7393D1"
    />
    <path
      d="M43 47C43 50.866 43 49.5 43 54C39.134 54 36 50.866 36 47C36 43.134 39.134 40 43 40C43 43 43 43.134 43 47Z"
      fill="#E24141"
    />
    <path
      d="M43 54C46.866 54 50 50.866 50 47C50 43.134 46.866 40 43 40V54Z"
      fill="#B12F2F"
    />
    <path
      d="M44.8955 44.1836C45.1389 43.9387 45.534 43.9386 45.7773 44.1836C46.0205 44.4286 46.0205 44.8263 45.7773 45.0713L43.8809 46.9795L45.8174 48.9287C46.0608 49.1738 46.0608 49.5713 45.8174 49.8164C45.574 50.0613 45.1789 50.0614 44.9355 49.8164L43 47.8672L41.0645 49.8164C40.8211 50.0614 40.426 50.0613 40.1826 49.8164C39.9392 49.5713 39.9392 49.1738 40.1826 48.9287L42.1182 46.9795L40.2227 45.0713C39.9795 44.8263 39.9795 44.4286 40.2227 44.1836C40.466 43.9386 40.8611 43.9387 41.1045 44.1836L43 46.0918L44.8955 44.1836Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.5 15.75C41.5 16.1642 41.1642 16.5 40.75 16.5H37.75C34.5744 16.5 32 13.9256 32 10.75V7.75C32 7.33579 32.3358 7 32.75 7C33.1642 7 33.5 7.33579 33.5 7.75V10.75C33.5 13.0972 35.4028 15 37.75 15H40.75C41.1642 15 41.5 15.3358 41.5 15.75Z"
      fill="white"
    />
  </SvgIcon>
);
